import { CellWrapper } from "@silevis/reactgrid";

import useFixedPopover from "./useFixedPopover";
import { cn } from "tools/ui";

const STATES = {
  active: { label: "Activo", color: "bg-emerald-500" },
  inactive: { label: "Inactivo", color: "bg-neutral-400" },
};

function EmployeeCell({ value, state, style }) {
  const { triggerRef, popoverPos, showPopover, hidePopover } =
    useFixedPopover();
  const stateInfo = STATES[state] ?? { label: state, color: "bg-amber-500" };

  return (
    <CellWrapper
      onStringValueRequested={() => value?.toString() || ""}
      onStringValueReceived={() => {}}
      style={style}
    >
      <span
        ref={triggerRef}
        onMouseEnter={() => state && showPopover()}
        onMouseLeave={hidePopover}
      >
        {value}
      </span>
      {popoverPos && state && (
        <div
          className="fixed z-50"
          style={{ left: popoverPos.left, top: popoverPos.top }}
          onMouseEnter={showPopover}
          onMouseLeave={hidePopover}
        >
          <div
            className={cn(
              "absolute top-3.5 w-2.5 h-2.5 rotate-45 bg-white",
              popoverPos.side === "left" ? "-right-1" : "-left-1",
            )}
          />
          <div className="w-max overflow-hidden rounded-xl border border-neutral-100 bg-white shadow-xl shadow-amber-900/10">
            <div className="flex items-center gap-2 px-3 py-2">
              <span className="text-[11px] font-bold uppercase tracking-wide text-neutral-400">
                Estado:
              </span>
              <span className="flex items-center gap-1.5 text-xs font-semibold text-neutral-900">
                <span className={cn("size-2 rounded-full", stateInfo.color)} />
                {stateInfo.label}
              </span>
            </div>
          </div>
        </div>
      )}
    </CellWrapper>
  );
}

export default EmployeeCell;
